(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orima-payment-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
 const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
 const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  entries.forEach(entry => {
   const panel = entry.target;
   panel.classList.toggle('is-in-view', entry.isIntersecting);
   if (entry.isIntersecting && !panel.dataset.revealed) {
    panel.dataset.revealed = 'true';
    if (!motion.matches) panel.classList.add('is-revealing');
   }
  });
 }, {threshold:0.05}) : null;
 const init = root => {
  root.querySelectorAll('.orima-payments').forEach(panel => {
   if (panel.dataset.motionReady) return;
   panel.dataset.motionReady = 'true';
   panel.querySelectorAll('.orima-payments__logos li').forEach((logo,index) => {
    logo.style.setProperty('--pay-delay', `${Math.min(index,24)*32}ms`);
    logo.style.setProperty('--pay-float-delay', `${index*-0.31}s`);
   });
   const pause = panel.querySelector('.orima-payments__pause');
   if (pause) {
    pause.hidden = false;
    pause.addEventListener('click', () => {
     const paused = panel.classList.toggle('is-paused');
     pause.setAttribute('aria-pressed', String(paused));
    });
   }
   let frame = null;
   panel.addEventListener('pointermove', event => {
    if (motion.matches || event.pointerType !== 'mouse' || panel.classList.contains('is-paused')) return;
    if (frame !== null) cancelAnimationFrame(frame);
    const x = event.clientX, y = event.clientY;
    frame = requestAnimationFrame(() => {
     const bounds = panel.getBoundingClientRect();
     panel.style.setProperty('--pay-x', `${x-bounds.left}px`);
     panel.style.setProperty('--pay-y', `${y-bounds.top}px`);
     frame = null;
    });
   });
   panel.addEventListener('pointerleave', () => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null;
    panel.style.removeProperty('--pay-x');
    panel.style.removeProperty('--pay-y');
   });
   if (observer) observer.observe(panel);
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
 else init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.orima-payments').forEach(panel => {if (observer) observer.unobserve(panel);});
 });
})();
  } catch(e) { console.error(e); }
})();

})();
